import { useState } from 'react';
import ImageUploadManager from '@/components/common/ImageUploadManager';
import { getSafeImageUrl } from '@/utils/image-utils';

interface ProfileImageUploadProps {
  currentImageUrl?: string | null;
  userId: string;
  onImageUpdated: (newImageUrl: string) => void;
}

export default function ProfileImageUpload({ 
  currentImageUrl, 
  userId, 
  onImageUpdated 
}: ProfileImageUploadProps) {
  // Ensure we have a valid URL
  const safeImageUrl = currentImageUrl ? getSafeImageUrl(currentImageUrl) : null;

  return (
    <ImageUploadManager
      currentImageUrl={safeImageUrl}
      onImageUpdated={onImageUpdated}
      imageType="profile"
      userId={userId}
      aspectRatio={1}
      shape="circle"
      className="h-full w-full"
    />
  );
}